import { BranchOfficeInventory } from '@api/BranchOfficeInventories/BranchOfficeInventory';
import BranchOfficeInventoryServ from '@api/BranchOfficeInventories/BranchOfficeInventoryServ';

// Limpieza v1 (2026-08-19): quedó SOLO la lectura. `saveInventory` y
// `updateInventory` escribían stock a mano — se fueron con la regla del 19-ago
// ("el stock no se edita a mano, se mueve por hechos") y ya no tenían pantalla
// que los llamara.

class BranchOfficeInventoryService {
    getInventory = (distributionCenterId: string, fillEmpty?: boolean): Promise<BranchOfficeInventory[]> => {
        return new Promise(async (resolve, reject) => {
            try {
                const data = await BranchOfficeInventoryServ.getInventory(distributionCenterId, fillEmpty);
                resolve(data);
            } catch (error) {
                reject('Error getting branch office inventory: ' + error);
            }
        });
    };
}
export default BranchOfficeInventoryService;
